import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { setMessage } from "./message"
import EventBus from "../../utils/EventBus"
import EMPLOYEEAPI from "../../Api/employee"

export const fetchEmployees = createAsyncThunk("employee/fetchEmployees", async (params, thunkAPI) => {
  try {
    const response = await EMPLOYEEAPI.getEmployees(params)
     return response.data   
  } catch (error) {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      EventBus.dispatch("logout");
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    thunkAPI.dispatch(setMessage(message));
    return thunkAPI.rejectWithValue(message)
  }
})

export const fetchEmployeeByid = createAsyncThunk("employee/fetchEmployeeByid", async (params, thunkAPI) => {
  try {
    const response = await EMPLOYEEAPI.getEmployeeByid(params)
    console.log("res",response.data)  

     return response.data 
  } catch (error) {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      EventBus.dispatch("logout");
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    thunkAPI.dispatch(setMessage(message));
    return thunkAPI.rejectWithValue(message)
  }
})

export const fetchInactiveEmployees = createAsyncThunk("employee/fetchInactiveEmployees", async (params, thunkAPI) => {
  try {
    const response = await EMPLOYEEAPI.getInactiveEmployees(params)
     return response.data   
  } catch (error) {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      EventBus.dispatch("logout");
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    thunkAPI.dispatch(setMessage(message));
    return thunkAPI.rejectWithValue(message)
  }
})

export const createEmployee = createAsyncThunk("roles/createEmployee", async (formData, thunkAPI) => {
  try {
    const response = await EMPLOYEEAPI.addEmployee(formData)
    const message=(response.message)

    thunkAPI.dispatch(setMessage(message))

    return response
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    thunkAPI.dispatch(setMessage(message));
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      EventBus.dispatch("logout");
    }
    return thunkAPI.rejectWithValue(message)
  }
})


export const updateEmployee = createAsyncThunk("roles/updateEmployee", async ({r_id, formData}, thunkAPI) => {
  try {
    const response = await EMPLOYEEAPI.updateEmployee(r_id, formData)
    const message=(response.message)
    
    thunkAPI.dispatch(setMessage(message))

    return response
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    thunkAPI.dispatch(setMessage(message))
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      EventBus.dispatch("logout");
    }
    return thunkAPI.rejectWithValue(message)
  }
})

export const updateEmployeeByUser = createAsyncThunk("roles/updateEmployeeByUser", async ({r_id, formData}, thunkAPI) => {
  try {
    const response = await EMPLOYEEAPI.updateEmployeeByUser(r_id, formData)
    const message=(response.message)
    
    thunkAPI.dispatch(setMessage(message))

    return response
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    thunkAPI.dispatch(setMessage(message))
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      EventBus.dispatch("logout");
    }
    return thunkAPI.rejectWithValue(message)
  }
})

const employeeSlice = createSlice({
  name: "employee",
  initialState: {
    employees: [],
    employeeDetail: null,
    totalCount: 0
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployees.fulfilled, (state, action) => {
        state.employees = action.payload.data;
        state.totalCount = action.payload.totalCount;
      })
      .addCase(fetchEmployeeByid.fulfilled, (state, action) => {
        state.employeeDetail = action.payload.data
        
      })
      .addCase(fetchInactiveEmployees.fulfilled, (state, action) => {
        state.employees = action.payload.data
        state.totalCount = action.payload.totalCount
      })
      .addCase(createEmployee.fulfilled, (state, action) => {
        state.employees.push(action.payload.data)
      })
       .addCase(updateEmployee.fulfilled, (state, action) => {
        console.log(action.payload);
              const {arg: { r_id }} = action.meta;
              if (r_id) {
                state.employees = state.employees.map((item) =>
                  item._id === r_id ? action.payload.data : item
                );
              };
        })
        .addCase(updateEmployeeByUser.fulfilled, (state, action) => {
          console.log(action.payload);
                const {arg: { r_id }} = action.meta;
                if (r_id) {
                  state.employees = state.employees.map((item) =>
                    item._id === r_id ? action.payload.data : item
                  );
                };
          })
  } 
})

const { reducer } = employeeSlice
export default reducer
